export function salesChannelIcon(channelCode) {
  if (channelCode) {
    const icon = ['shopee_id','tokopedia_id', 'tiktok', 'tiktok_id', 'blibli_id', 'lazada_id', 'zalora_id', 'accurate_pos'].includes(channelCode) ? require(`@/assets/store/${channelCode}.png`) : null
    return icon || require('@/assets/images/logo_small.png');
  }
  return null
}
